<template lang="pug">
.flex-centered.full-height
  .loading.loading-lg
</template>

<script>
import { LocalStorageFacade } from 'paliari-js-utils'
import departamento from '@/lib/departamento'

export default {
  methods: {
    async redirect() {
      await this.$auth.current()
      if (departamento.current) {
        this.$router.replace({ name: 'app.home' })
      } else {
        this.$router.replace({ name: 'departamentos' })
      }
    },
  },
  created() {
    if (this.$route.query && this.$route.query._t) {
      LocalStorageFacade.setItem('auth_token', this.$route.query._t)
    }
    this.redirect()
  },
}
</script>
